<template>
  <v-split-to-do-list title="Actielijst" :toDos="toDos" archive>
  </v-split-to-do-list>
</template>

<script>
import axios from 'axios';
import VSplitToDoList from './SplitToDoList'
import { takeUntil } from 'rxjs/operators';
import { toDoClosedEventStream$ } from './toDoClosedEventStream';
import { toDoArchiveEventStream$ } from './toDoArchiveEventStream';
import { departmentChangedEventStream$ } from '@/components/sections/navigation/departmentChangedEventStream'

export default {
  name: 'v-ppw-rec-id-to-do-list',
  components: { VSplitToDoList },
  data () {
    return {
      toDos: []
    }
  },
  created () {
    this.fetchTodos();
    // Listen for departmentChangedEvents. They need to be removed from the cached todos.
    departmentChangedEventStream$.pipe(
      takeUntil(this.$eventToObservable('hook:beforeDestroy'))
    ).subscribe(e => {
      this.fetchTodos();
    });
    // Listen for todoclosedevents. They need to be removed from the cached todos.
    toDoClosedEventStream$.pipe(
      takeUntil(this.$eventToObservable('hook:beforeDestroy'))
    ).subscribe(e => {
      if (this.toDos.length === 0) {
        return; // no todo's in cache means nothing to remove
      }
      const filteredToDos = this.toDos.filter(v => v.id !== e.toDoId);
      if (filteredToDos.length === this.toDos.length) {
        return; // same number of todo's means nothing was removed and reassigning toDo's is useless.
      }
      this.toDos = filteredToDos;
    });
    // Listen for archiveEvents. They need to be removed from the cached todos.
    toDoArchiveEventStream$.pipe(
      takeUntil(this.$eventToObservable('hook:beforeDestroy'))
    ).subscribe(e => {
      this.fetchTodos();
    });    
  },
  methods: {
    /**
     * @function fetchTodos - function to get todos
     */
    fetchTodos () {
      axios.get('Todolist/PpwRecIdToDoList').then(response => {
        this.toDos = response.data;
      });
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
